<template>
  <AppLayout class="reports" title="Exports" centered>
    <template v-slot:header>
      <div class="reports__date ml-2">
        <DatePicker
          showValidationErrors
          label=""
          is-range
          hide-details
          @onChange="onDateChange"
          class="date-picker-wrapper--no-label"
        />
      </div>
    </template>
    <template v-slot:body>
      <div class="container col-lg-10 col-sm-12">
        <div class="d-flex align-center">
          <v-tabs v-model="selectedTab" class="basic-tabs mt-1 mb-3" centered>
            <v-tab
              v-for="(component, sectionName) in reportSections"
              :key="sectionName"
            >
              {{ sectionName }}
            </v-tab>
          </v-tabs>
          <base-button
            class="reports__reload mr-2 mb-0"
            shrink
            @click="handleReload"
            v-if="selectedTab === 1"
          >
            <v-icon>mdi-refresh</v-icon> Refresh
          </base-button>
        </div>

        <component
          :is="Object.values(reportSections)[selectedTab]"
          :date-range="dateRange"
          :clients="clients"
          :permissions="permissions"
          ref="reportsContent"
          @openDialog="setActiveDialog"
        />
      </div>
    </template>
  </AppLayout>
</template>

<script>
import AppLayout from "@/components/common/base-layouts/AppLayout";
import DatePicker from "@/components/common/DatePicker";
import Exports from "@/views/exports/Exports";
import UserExports from "@/views/exports/UserExports";
import BaseButton from "@/components/common/Button/BaseButton";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { createNamespacedHelpers } from "vuex";
import Select from "@/components/common/Select";
import { AGENCY_NAMESPACE } from "@/store/modules/agencies";
import { FETCH_ALL_AGENCIES } from "@/store/modules/agencies/action-types";

const { mapState: authMapState } = createNamespacedHelpers(AUTH_NAMESPACE);
const { mapState, mapActions } = createNamespacedHelpers(AGENCY_NAMESPACE);

export default {
  components: {
    AppLayout,
    DatePicker,
    UserExports,
    BaseButton,
    Select
  },
  data: () => ({
    search: null,
    selectedTab: null,
    activeDialog: null,
    dateFrom: null,
    dateTo: null,
    dateRange: null,
    invalidDaterange: false,
    error: {
      title: `Invalid Date`,
      detail: `Please select correct Date Range`
    },
    clients: []
  }),
  created() {
    const filter = {
      organisation_type: "client",
      is_root: true
    };
    this.getAllClients({ filter });
  },
  computed: {
    ...authMapState(["permissions"]),
    ...mapState({
      agencies: state => state.agencies,
      isLoading: state => state.isFetchingData
    }),
    reportSections() {
      let sections = {};
      sections["Exports"] = Exports;
      sections["My Requests"] = UserExports;

      return sections;
    }
  },
  methods: {
    ...mapActions({
      getAllClients: FETCH_ALL_AGENCIES
    }),
    setActiveDialog(name) {
      this.activeDialog = name;
    },
    onDateChange(val) {
      this.dateRange = val;
    },
    handleReload() {
      this.$refs.reportsContent.fetchUserReports();
    }
  }
};
</script>

<style lang="scss" scoped>
.reports {
  &__reload {
    position: absolute;
    right: 0;
    z-index: 3;
  }
}
.exports-tab-container {
  .v-slide-group__content {
    justify-content: center;
  }
}
</style>
